import { Observable } from "rxjs";
import { ELocalizationLang } from "../enums/localization-lang.enum";
import { Signal } from "@angular/core";
import AuthUserModelInterface from "@app/kernel/shared/interfaces/auth-user-model.interface";

export abstract class TopNavAbstraction {
  abstract authenticatedUser: Signal<AuthUserModelInterface | null>;
  abstract changeMyPreferredLang(lang: ELocalizationLang): Observable<boolean>;
}
